angular
    .module('quattro.bmbo.search', [
        'ngRoute',
        'quattro.bmbo.search.service',
        'quattro.bmbo.search.box',
        'quattro.bmbo.account.modal-edit',
        'quattro.bmbo.mailinglist.modal-edit',
        'quattro.bmbo.domain.modal-edit',
        'quattro.bmbo.email.modal-edit',
    ])
    .controller('SearchController', function ($scope, $routeParams, $location, searchService) {

        var vm = this;

        this.searchService = searchService.scope;
        this.deep = !!$location.search().deep;

        $scope.$watch(function () {
            return vm.deep;
        }, function (value) {
            $location.search('deep', !!value || null);
            searchService.search(query, value);
        });

        var query = $routeParams.query;

        // init global input field
        searchService.scope.query = query;

        searchService.search(query, vm.deep);


        // custom events will trigger modal edit

        this.editAccount = function (account) {
            $scope.$emit('vq.bmbo.account.edit', account);
        };
        this.editMailinglist = function (mailinglist) {
            $scope.$emit('vq.bmbo.mailinglist.edit', mailinglist);
        };
        this.editDomain = function (domain) {
            $scope.$emit('vq.bmbo.domain.edit', domain);
        };
        this.editMail = function (mail) {
            $scope.$emit('vq.bmbo.email.edit', mail);
        };
    });
